import React from 'react';

import { CircleLoader } from './CircleLoader';

interface Props {
  loading: boolean;
  onClick: () => void;
  dataTestId?: string;
}

export const LoadMoreButton: React.FC<Props> = ({
  loading,
  onClick,
  dataTestId
}) => {
  return (
    <button
      data-testid={dataTestId}
      disabled={loading}
      className="w-[200px] h-[48px] flex justify-center items-center gap-x-2 text-brand-300 font-medium text-base px-[24px] py-[8px] lg:py-[14px] rounded-[41px] border-[1px] border:solid border-brand-300"
      onClick={onClick}
    >
      {loading ? <CircleLoader color="red" /> : null} Xem thêm
    </button>
  );
};
